export const columns = [
    {
        columnId: 1,
        name: "操作",
        key: "handle",
        width: "60",
    },
    {
        columnId: 2,
        name: "处理方式",
        key: "handleType",
        width: 80,
    },
    {
        columnId: 3,
        name: "不良件编号",
        key: "id",
        width: 90,
    },
    {
        columnId: 4,
        name: "创建时间",
        key: "createTime",
        width: 90,
    },
    {
        columnId: 5,
        name: "用户ID",
        key: "userName",
        width: 90,
    },
    // {
    //     columnId: 6,
    //     name: "客户名",
    //     key: "customerName",
    //     width: 120,
    // },
    {
        columnId: 7,
        name: "订单编号",
        key: "orderNo",
        width: 70,
    },
    {
        columnId: 8,
        name: "商品信息",
        key: "goodsInfo",
        width: 200,
    },
    {
        columnId: 9,
        name: "商品数量",
        key: "count",
        width: 70,
    },
    {
        columnId: 10,
        name: "图片",
        key: "problemUrl",
        width: 80,
    },
    {
        columnId: 11,
        name: "不良图片",
        key: "problemImg",
        width: 80,
    },
    // {
    //     columnId: 12,
    //     name: "不良情况",
    //     key: "badSituation",
    //     width: 80,
    // },
    {
        columnId: 13,
        name: "不良视频",
        key: "brokenCount",
        width: 120,
    },
    {
        columnId: 12,
        name: "不良数量",
        key: "badCount",
        width: 120,
    },
    {
        columnId: 14,
        name: "不良描述",
        key: "badDescription",
        width: 80,
    },
    {
        columnId: 15,
        name: "处理说明",
        key: "handleDescription",
        width: 150,
    },
    {
        columnId: 16,
        name: "处理状态",
        key: "handleState",
        width: 100,
    },
    {
        columnId: 17,
        name: "处理日期",
        key: "handleTime",
        width: 90,
    },
    {
        columnId: 18,
        name: "退货运费",
        key: "returnFee",
        width: 80,
    },
    {
        columnId: 19,
        name: "发回运单号",
        key: "returnWaybillNo",
        width: 100,
    },
    {
        columnId: 20,
        name: "重发运单号",
        key: "waybillNumber",
        width: 100,
    },
    {
        columnId: 21,
        name: "退货地址",
        key: "returnAddress",
        width: 100,
    },
    {
        columnId: 22,
        name: "客户期望处理方式",
        key: "cusHandleType",
        width: 100,
    },
    {
        columnId: 23,
        name: "采购/检品工作签",
        key: "remark",
        width: 160,
    },
    // {
    //     columnId: 22,
    //     name: "购买订单号",
    //     key: "buyOrderNumber",
    //     width: 100,
    // },
];
